import { useEffect } from "react";
import { Row } from "react-bootstrap";
import { useDispatch, useSelector } from "react-redux";
import { useParams } from "react-router-dom";
import CommonHeader from "../ComponentsWeb/Sub/CommonHeader";
import Footer from "../ComponentsWeb/Sub/Footer";
import { getSinglePage } from "../reducers/frontEndReducer";
import NotFoundPage from "./NotFoundPage";

const DynamicPages = () => {
  const dispatch = useDispatch();
  let params = useParams();
  useEffect(() => {
    dispatch(
      getSinglePage({
        slug: params?.slug,
      })
    );
  }, []);
  const { getSinglePageData } = useSelector((state) => state.frontEndReducer);

  return (
    <>
      <CommonHeader />
      <div className="container-fluid">
        <div className="page-main p-5">
          {!!getSinglePageData ? (
            <>
              <Row
                dangerouslySetInnerHTML={{
                  __html: getSinglePageData?.description,
                }}
              />
            </>
          ) : (
            <NotFoundPage />
          )}
        </div>
      </div>
      <Footer />
    </>
  );
};

export default DynamicPages;
